import { useTranslation } from 'react-i18next';

function Bibliography({ bibliography }) {
    const { t } = useTranslation();

    return (
        <div className="bibliography has-background-light radius flow">
            <h2 className="is-family-secondary has-text-primary is-uppercase is-size-3">
                {t('articulos y libros')}
            </h2>
            <div className="py-5">
                <ul className="list-reset is-flex is-flex-direction-column gap-4">
                    {bibliography &&
                        bibliography.length > 0 &&
                        bibliography.map((item, index) => {
                            const {
                                ref_publications_authors: authors,
                                ref_publications_title: title,
                                ref_publications_date: date,
                                ref_publications_typology: typologyJson,
                            } = item;
                            let typology;
                            try {
                                typology = JSON.parse(typologyJson)?.[0];
                            } catch {
                                typology = null;
                            }
                            if (!typology || (typology !== '1' && typology !== '29')) return null;
                            if (!title) return null;
                            const typologyText = typology === '1' ? t('libro') : t('articulo');
                            const className = typology === '1' ? 'book-item' : 'article-item';

                            return (
                                <li key={'biblio-' + index}>
                                    <div className="has-background-white radius">
                                        <div className={`flow ${className}`}>
                                            <p className="is-size-5 is-uppercase has-text-primary is-family-secondary">
                                                <strong>{typologyText}</strong>
                                            </p>
                                            {authors && (
                                                <p className="is-size-6 has-text-weight-light">
                                                    <i>{authors}</i>
                                                </p>
                                            )}
                                            <p className="is-size-5 has-text-weight-light">
                                                <strong>{title}</strong>.{' '}
                                            </p>
                                            {date && (
                                                <p className="is-size-6 has-text-weight-light">
                                                    ({date})
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
}

export default Bibliography;
